import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const ManageGradProgramPageContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/ManageGradProgramPageContainerLoadable" */
      './ManageGradProgramPageContainer'
    ),
  loading: LoadableLoadingSection,
});
